// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedProduct: Object,
};

const DeleteProduct = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedProduct,
  } = props;

  const deleteProduct = () => {
    submit(selectedProduct.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteProduct} type="danger">Delete</SpButton>,
      ]}
      title="Delete Product"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this product?</div>
        <SpH5 className="pb-3">
          <div>{selectedProduct.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteProduct;
